var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-featuredArticles"},[_c('load-indicator',{attrs:{"request":"articles"}}),(_vm.featArticles)?_c('ul',_vm._l((_vm.featArticles),function(a){return _c('li',{key:a.Id},[_c('f-link',{attrs:{"has-text-decoration":false,"to":{
          name: 'article',
          params: {
            id: a.Id,
            slug: _vm.getSlug(a.Title)
          },
          props: true
        },"link-class":_vm.getIconClass(a)}},[_c(_vm.getIconType(a),{tag:"component",attrs:{"width":"160"}}),_vm._v(" "+_vm._s(a.Title)+" ")],1)],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }